"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var lodash_1 = require("lodash");
var recompose_1 = require("recompose");
var report_problem_1 = __importDefault(require("material-ui/svg-icons/action/report-problem"));
var uploader_1 = __importDefault(require("../../libs/navjobs-upload/uploader"));
var upload_field_1 = __importDefault(require("../../libs/navjobs-upload/upload-field"));
var IconButton_1 = __importDefault(require("../controls/IconButton"));
var UASUploader = function (_a) {
    var url = _a.url, fields = _a.fields, accept = _a.accept, onComplete = _a.onComplete, children = _a.children, request = _a.request, validate = _a.validate, handleFiles = _a.handleFiles, hideProgress = _a.hideProgress, multiple = _a.multiple, overwriteId = _a.overwriteId, rest = __rest(_a, ["url", "fields", "accept", "onComplete", "children", "request", "validate", "handleFiles", "hideProgress", "multiple", "overwriteId"]);
    return (react_1.default.createElement(uploader_1.default, __assign({ request: __assign({ fileName: 'file', url: url, method: overwriteId ? 'PUT' : 'POST', fields: fields, headers: {
                Accept: 'application/json',
            } }, request), onComplete: onComplete, overwriteId: overwriteId, uploadOnSelection: true }, rest), function (_a) {
        var onFiles = _a.onFiles, progress = _a.progress, error = _a.error;
        return (react_1.default.createElement("div", { style: { display: 'flex', alignItems: 'center' }, className: "multifile-uploader-label" },
            react_1.default.createElement(upload_field_1.default, { onFiles: handleFiles(onFiles), uploadProps: {
                    accept: accept,
                    multiple: multiple,
                } }, children),
            !hideProgress && (react_1.default.createElement("span", { style: { marginLeft: 15, display: 'flex', alignItems: 'center' } }, !progress ? null : progress + " %")),
            !!error && (react_1.default.createElement(IconButton_1.default, { tooltip: react_1.default.createElement("span", { style: { whiteSpace: 'normal ' } }, 'během nahrávání souboru došlo k chybě, zkuste znovu'), touch: true, tooltipPosition: "top-left", tooltipStyles: { width: 320, transition: null }, style: { padding: 0, width: 24, height: 24 } },
                react_1.default.createElement(report_problem_1.default, { focusable: "false", color: "rgb(228,31,24)" })))));
    }));
};
exports.default = recompose_1.compose(recompose_1.defaultProps({
    fields: {},
    setInternalError: lodash_1.noop,
    errorFunction: function () { return true; },
}), recompose_1.withHandlers({
    handleFiles: function (props) {
        return lodash_1.memoize(function (onFiles) { return function (files) {
            var validate = recompose_1.compose(lodash_1.isEmpty, props.errorFunction);
            if (files.length > 0 && lodash_1.every(files, validate)) {
                props.setInternalError('');
                // const filesArr = Object.keys(files).map(key => files[key]);
                var filesArr_1 = Array.from(files);
                // IE doesn't support for multiple files upload
                if (detectIE()) {
                    onFiles(files);
                }
                else {
                    filesArr_1.forEach(function (_, i) {
                        var dataTransfer = new DataTransfer();
                        dataTransfer.items.add(files.item(i));
                        onFiles(dataTransfer.files);
                        // ugly fix of magic bug with multiple files
                        if (!!i && i === filesArr_1.length - 1) {
                            onFiles(dataTransfer.files);
                        }
                    });
                }
            }
            else {
                var errors = lodash_1.map(files, props.errorFunction);
                props.setInternalError(lodash_1.find(errors, lodash_1.isString));
            }
        }; });
    },
}))(UASUploader);
/**
 * detect IE
 * returns version of IE or false, if browser is not Internet Explorer
 */
function detectIE() {
    var ua = window.navigator.userAgent;
    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }
    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }
    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }
    // other browser
    return false;
}
//# sourceMappingURL=Uploader.js.map


//////////////////
// WEBPACK FOOTER
// .-core/es/components/controls/Uploader.js
// module id = 1084
// module chunks = 0